angular.module('picmonicng').controller('PathwaysPicmonicController', [
  '$scope',
  '$state',
  '$stateParams',
  '$browseStateParams',
  '$sce',
  'Tracks',
  'PlaylistService',
  'UserService',
  '$filter',
  'MarketOptionsConfig',
  'FacebookService',
  '$cookies',
  '$location',
  'Pathways',
  'BrowseService',
  '$rootScope',
  'MetaService',
  'MarketSelectorModalService',
  'Picmonics',
  '$anchorScroll',
  'ReferralResource',
  'ReferralDataService',
  'MetatagResource',
  '$interval',
  '$timeout',
  '$http',
  'SplitTestService',
  function (
    $scope,
    $state,
    $stateParams,
    $browseStateParams,
    $sce,
    Tracks,
    PlaylistService,
    UserService,
    $filter,
    MarketOptionsConfig,
    FacebookService,
    $cookies,
    $location,
    Pathways,
    BrowseService,
    $rootScope,
    MetaService,
    MarketSelectorModalService,
    Picmonics,
    $anchorScroll,
    ReferralResource,
    ReferralDataService,
    MetatagResource,
    $interval,
    $timeout,
    $http
  ) {
    $scope.$sce = $sce;
    $scope.$state = $state;
    $scope.UserService = UserService;
    $scope.BrowseService = BrowseService;
    $scope.dataChanged = false;
    $scope.onBooks = $state.current.name.indexOf('books') > -1;
    $scope.currentMarket = $scope.market = MarketOptionsConfig.getMarketBySlug(
      $browseStateParams.market ? $browseStateParams.market : $stateParams.market
    );
    $scope.osmosis = $stateParams.osmosis;
    $scope.ReferralDataService = ReferralDataService;
    $scope.user_count = window.pls_config.user_count;

    // Build breadcrumb urls
    var parts = $location.$$path.split('/');
    $scope.breadcrumbs = [$location.$$protocol + '://' + $location.$$host + $location.$$path];
    for (i = 0; i < 5; i++) {
      parts.pop();
      $scope.breadcrumbs.unshift($location.$$protocol + '://' + $location.$$host + parts.join('/'));
    }

    if ($stateParams.osmosis) {
      $scope.company = 'Osmosis';
      $scope.logo = '/assets/img/osmosis/osmosis_logo.png';
    } else if ($stateParams.amboss) {
      $scope.company = 'AMBOSS';
      $scope.logo = '/assets/img/osmosis/amboss_logo.svg';
    } else if ($stateParams.lecturio) {
      $scope.company = 'Lecturio';
      $scope.logo = '/assets/img/osmosis/lecturio_logo.svg';
    }

    card_id = $stateParams.card_id;
    track_id = $stateParams.track_id;

    if ($stateParams.card_id && $stateParams.card_id.indexOf('_') !== false) {
      card_id = $stateParams.card_id.split('_')[1];
    }

    if ($stateParams.track_id && $stateParams.track_id.indexOf('-') !== false) {
      track_id = $stateParams.track_id.split('-').pop();
    }

    $scope.recommended = Picmonics.queryv3({
      resource: 'recommended',
      card_id: card_id,
      track_id: track_id,
    });

    $scope.selectedTweet = 0;

    var interval = $interval(function () {
      $scope.scrollTweets(1);
    }, 5000);

    this.$onDestroy = function () {
      $interval.cancel(interval);
    };

    $scope.scrollTweets = function (scroll) {
      $scope.selectedTweet = ($scope.selectedTweet + scroll + 6) % 6;
    };

    $http.get('/api/v3/pathways/courses').then(function (response) {
      $scope.pathways = response.data;
    });

    $scope.openMarket = '';
    $scope.openSection = function (section) {
      if ($scope.openMarket && $scope.openMarket != section) {
        $timeout(function () {
          var offset = $anchorScroll.yOffset;
          offset = 104;
          $anchorScroll(section);
          $anchorScroll.yOffset = offset;
        }, 0);
      }
      $scope.openMarket = $scope.openMarket == section ? false : section;
    };

    $scope.search = function (searchTerm) {
      UserService.setMarketCookies(100);
      $scope.searching = true;

      $scope.results = Picmonics.search({
        source: 'find-picmonic',
        query: searchTerm,
        page: 1,
        searchPicmonics: true,
        searchPathways: true,
        searchBreadcrumbs: true,
        sort_by: 'relevance',
        include_ugc: false,
        quick: 1,
      });

      $scope.results.$promise.finally(function () {
        $scope.searching = false;
        if ($scope.results.total > 0) {
          $scope.searchOpen = true;
        }
      });
    };

    $scope.closeSearch = function () {
      $timeout(function () {
        $scope.searchOpen = false;
      }, 100);
    };

    $scope.goToPathway = function (pathway) {
      var browseParams = encodeURIComponent(
        JSON.stringify({
          curriculum: pathway.root_curriculum,
          market: MarketOptionsConfig.getMarketById(pathway.root_market_id).slug,
          pathway_id: pathway.root_pathway_id,
          track_id: pathway.track_id,
          scroll_to: pathway.further_sub_pathway_id ? pathway.further_sub_pathway_id : pathway.sub_pathway_id,
        })
      );

      redirect =
        '/find-picmonic?browse=app.pathways.market.' +
        pathway.root_pathway_type +
        '.tracks' +
        (pathway.track_id ? '.picmonics' : '') +
        '&browseParams=' +
        browseParams +
        '&browseOptions=%7B"open":true%7D';

      if (UserService.user.user_id) {
        window.location = redirect;
      } else {
        UserService.showRegisterModal(false, redirect);
      }
    };

    $scope.generateBreadCrumbs = function (item) {
      var buffer = '';
      var arrow_right = ' &rsaquo; ';

      if (item.root_pathway_pathway_type) {
        if (UserService.user && UserService.user.lead) {
          var config = MarketOptionsConfig.getMarketById(UserService.user.lead);
          var found = false;
          angular.forEach(config.sections, function (section) {
            if (
              section.pathway_type == item.root_pathway_pathway_type &&
              section.curriculum == item.root_pathway_curriculum &&
              !found
            ) {
              buffer += $filter('ucfirst')(section.name);
              found = true;
            }
          });
        } else {
          buffer += $filter('ucfirst')(item.root_pathway_pathway_type);
        }
      }

      if (item.root_pathway_name) {
        if (buffer.length) {
          buffer += arrow_right;
        }
        buffer += item.root_pathway_name;
      }

      return buffer;
    };

    if (UserService.user.user_id) {
      $location.url('/learn/' + $stateParams.card_id);
    }

    // Required for the learn fact directive, and setting the mode shows definitions
    // this needs to be fixed or refactored at some point.
    $scope.PlayerService = {
      mode: 'player',
    };

    UserService.setCookieIfNotLoggedIn('role', 'Student');

    //Scroll past copy on public picmonic when navigating from public pathways
    //offset is set to account for navigationbar and breadcrumbs
    if ($location.search().scroll_to == 'content') {
      $anchorScroll.yOffset = 132;
      $anchorScroll('public-picmonic-content');
    }

    // Get Card
    $scope.card = Picmonics.get({ slug: $stateParams.card_id }, function (card) {
      if (!BrowseService.browseOpen) {
        MetaService.replace('%PATHWAY%', card.name);
        MetaService.replace(
          '%DESCRIPTION%',
          'Learn ' +
            card.name +
            " faster and easier with Picmonic's unforgettable images and stories! Picmonic is research proven to increase your memory retention and test scores. Start learning today for free!"
        );
        MetaService.replace('%MARKET%', $scope.market.name);

        if ($stateParams.register) {
          $scope.register(false);
        }
      }
    });

    MetatagResource.get({ url: $location.$$path }, function (data) {
      if (data.h1) {
        $scope.replaceH1 = data.h1;
      }

      if (data.h2) {
        $scope.replaceH2 = data.h2;
      }

      if (data.title) {
        MetaService.replace('%PATHWAY%', data.title);
      } else {
        MetaService.replace('%PATHWAY%', 'Pathways');
      }
    });

    // Get Pathway
    var pathway_slug = String(
      $browseStateParams.pathway_id ? $browseStateParams.pathway_id : $stateParams.pathway_id
    ).split('-');
    var pathway_id = pathway_slug[pathway_slug.length - 1];
    $scope.pathway = Pathways.getv3({ pathway_id: pathway_id });

    // Get Track
    var track_slug = String($browseStateParams.track_id ? $browseStateParams.track_id : $stateParams.track_id).split(
      '-'
    );
    var track_id = track_slug[track_slug.length - 1];
    $scope.trackInfo = Tracks.get({ track_id: track_id });

    $scope.register = function (card) {
      var redirect =
        '/learn/' +
        (card ? card.slug : $scope.card.slug) +
        '?browse=' +
        BrowseService.state +
        '&browseParams=' +
        JSON.stringify(BrowseService.params) +
        '&browseOptions=' +
        JSON.stringify({ open: false });
      UserService.setMarketCookies($scope.currentMarket.id);
      UserService.showRegisterModal(false, redirect);
    };
  },
]);
